export default {"src":"/seller-forums/_next/static/media/noDiscussion.b7da2f88.svg","height":96,"width":98};